import React from "react";

const TableSubsystems = ({tableItems}) => {
  return (
    <table className="table__subsystems">
      <thead>
      <tr className="iransans-m">
        <th style={{width: "36px"}}>ردیف</th>
        <th style={{width: "100px"}}>کد زیر سیستم</th>
        <th style={{width: "100px"}}>نام زیر سیستم</th>
        <th>وظیفه</th>
      </tr>
      </thead>
      <tbody>
      {tableItems
        ? tableItems.map((item, index) => (
          <tr key={index} className="iransans-b">
            <td>{index+1}</td>
            <td>{item.id}</td>
            <td>{item.name}</td>
            <td>{item.task}</td>
          </tr>
        ))
        : null}
      </tbody>
    </table>
  );
};

export default TableSubsystems;
